import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const Footer = () => {
  return <footer className="bg-black text-gray-400 py-12 px-4 md:px-6 lg:px-8 border-t border-gray-800" data-id="element-93">
      <div className="max-w-7xl mx-auto" data-id="element-94">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-95">
          {/* Company Info Column */}
          <div className="flex flex-col items-center md:items-start" data-id="element-96">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.7
          }} className="mb-4" data-id="element-97">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8FoTH3xeKncC1VAra4Rj1n/partners516.png" alt="516 Partners Lion Logo" className="h-10 w-auto" data-id="element-98" />
            </motion.div>
            <p className="text-sm mt-3 text-center md:text-left" data-id="element-99">
              Bringing Wall Street financial firepower to support the backbone
              of America.
            </p>
          </div>
          {/* Quick Links Column */}
          {/* Contact Column */}
          <div className="flex flex-col items-center md:items-start" data-id="element-100">
            <h3 className="text-white text-lg font-semibold mb-4 typekit-heading" data-id="element-101">
              Contact Us
            </h3>
            <ul className="space-y-2" data-id="element-102">
              <li className="flex items-center gap-2" data-id="element-103">
                <MapPinIcon className="h-4 w-4 text-[#ffdf07]" data-id="element-104" />
                <span className="text-sm" data-id="element-105">
                  5 Cowboys Way STE 300, Frisco, Texas
                </span>
              </li>
            </ul>
          </div>
        </div>
        {/* Divider */}
        <div className="border-t border-gray-800 my-6" data-id="element-106"></div>
        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-107">
          <div className="mb-4 md:mb-0" data-id="element-108">
            <p className="text-sm" data-id="element-109">
              © 2025 516 Partners. All rights reserved.
            </p>
          </div>
          <div className="flex space-x-6" data-id="element-110">
            <Link to="/privacypage" className="text-sm hover:text-[#ffdf07] transition-colors" data-id="element-111">
              Privacy Policy
            </Link>
            <Link to="/termsofservice" className="text-sm hover:text-[#ffdf07] transition-colors" data-id="element-112">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;